import React from 'react';

interface Props {
  label?: string;
  backgroundColor?: string;
  textColor?: string;
  className?: string;
}

export default function CustomLabel(props: Props) {
  const { label, backgroundColor, textColor, className } = props;

  const container = 'flex flex-wrap justify-center items-center rounded-[6px] px-[5px] py-2xs relative overflow-hidden';

  return (
    <div className={`${container} ${className}`} style={{ backgroundColor: backgroundColor }}>
      <span className="text-center font-medium truncate" style={{ color: textColor }}>
        {label}
      </span>
    </div>
  );
}
